// extracted by mini-css-extract-plugin
module.exports = {"thankYouContainer":"ThankYou_thankYouContainer__FsoLv","thankYouMessage":"ThankYou_thankYouMessage__TzAql"};